import React, { useRef } from 'react';
var VeltActivityLogHeaderFilterTriggerLabel = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-header-filter-trigger-label", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltActivityLogHeaderFilterTriggerLabel;
